import { useGetUser } from '@/hooks/useGetUser';
import { Loading } from '@/ui';
import { allowLogin } from '@final-commerce/jwt-storage-lib';
import { Suspense, useEffect, useState } from 'react';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { checkIfUserIsAllowedToUseCDK, redirectToLoginInHub } from './helpers';

export const PrivateRoute = () => {
  const [allowedToUseApp, setAllowedToUseApp] = useState(false);
  const { fetchUser } = useGetUser();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkIfUserIsAllowedToUseApp = async () => {
      const allowed = await allowLogin();
      if (!allowed) {
        // No shared session (jwt_me): nothing to decode, nothing to render —
        // without this branch the spinner never ends. The Hub owns the login.
        redirectToLoginInHub();
        return;
      }
      checkIfUserIsAllowedToUseCDK();
      await fetchUser();
      setAllowedToUseApp(allowed);
      setLoading(false);
    };
    checkIfUserIsAllowedToUseApp();
  }, [navigate]);

  if (loading) {
    return <Loading />;
  }

  return <Suspense>{allowedToUseApp ? <Outlet /> : <Navigate to={`/login`} />}</Suspense>;
};
